import StaticSelectOption from 'store/types/StaticSelectOption';

const regions: StaticSelectOption[] = [
  {
    value: 'America',
    text: 'America',
  },
  {
    value: 'China',
    text: 'China',
  },
  {
    value: 'Europe',
    text: 'Europe',
  },
  {
    value: 'Japan',
    text: 'Japan',
  },
  {
    value: 'Korea',
    text: 'Korea',
  },
  {
    value: 'SEA',
    text: 'SEA',
  },
  {
    value: 'Taiwan',
    text: 'Taiwan',
  },
];

export default regions;
